module.exports = __webpack_public_path__ + "img/WhatsApp_icon.d266b611.png";